import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import NavBar from './NavBar';
import axios from 'axios';
import apiurl from './apiurl';
import Export_bestia from './Export_bestia';
import BudzetZadaniowy from './BudzetZadaniowy';

export default class Lista extends React.Component {
  constructor(props) {
    super(props); 
    
    this.state = {
    token: props.token ,
    username: props.username ,
    kodoper: props.kodoper,
    rok: props.rok,
    nazwastrony: "Lista",
    data1: [],
    data2: [],
    dataf: [],
    user: [],
    sorta: '',
    filtr1: '',
    filtr2: '',
    filtr3: '',
    filtr4: '',
    id: '',
    isVisible: false,
    isLoadingdane: false,
    isVisible3: true,
    brak: false,
    loading: true,
    wersja_mini: true,
    };
    this.onLista();
  }

  componentDidMount(){
    ReactDOM.render(<NavBar token = {this.state.token} username = {this.state.username} id = {this.state.id} rok = {this.state.rok} nazwastrony = {this.state.nazwastrony} kodoper = {this.state.kodoper} />, document.getElementById("header")); 
    this.setState({ sorta: "1" }, () => { this.sprawdzenie() });
  }

  componentWillUpdate(nextProps){
    if(this.state.rok !== nextProps.rok ){
      this.setState({ rok : nextProps.rok}, () => { this.sprawdzenie() })
    } else {
      
    }
  }

  onChangee = (z) => {
   
    this.setState({ [z.target.name]: z.target.value }, () => { this.sprawdzenie() });

  }

  sprawdzenie = () => {
    const {sorta} = this.state;
    if (sorta === '1') {
      this.setState({ filtr1: '0', filtr2: '1',  filtr3: '2', filtr4: '3' }, () => { this.filtrowanie() });
    }
    if (sorta === '2') {
      this.setState({ filtr1: '30', filtr2: '31',  filtr3: '32', filtr4: '33' }, () => { this.filtrowanie() });
    }
    if (sorta === '3') {
      this.setState({ filtr1: '10', filtr2: '11',  filtr3: '12', filtr4: '13' }, () => { this.filtrowanie() });
    }
    if (sorta === '4') {
      this.setState({ filtr1: '20', filtr2: '21',  filtr3: '22', filtr4: '23' }, () => { this.filtrowanie() });
    }
    else {

    }
  }

  onLista = () => {
    axios
      .get(apiurl+"api/Uchwaly?", { params : {rok : this.state.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }})
      .then(response => 
        response.data.map(data1 => ({
          id: `${data1.iD_Uchwaly}`,
          lp: `${data1.lp}`,
          statid: `${data1.statId}`,
          status: `${data1.status}`,
          dataotw: `${data1.data_Otw}`,
          dataprzyj: `${data1.data_Przyj}`,
          nazwa: `${data1.nazwa}`,
        })) 
      )
      .then(data1 => {
        data1.sort((a, b) => a.lp - b.lp).reverse();
        this.setState({ data1, loading: false });
        this.filtrowanie();
      })
      .catch(error => this.setState({ error, isLoading: false, loading: false }));
  }

  zmiana = (user) => {
    this.setState({ id: `${user.id}`, nazwauchwaly: `${user.nazwa}`}, () => { this.dalej(user.statid) });
  }

  filtrowanie() { 
  let {data1, filtr1, filtr2, filtr3, filtr4 } = this.state;
  // this.setState({ dataf : data1.filter(({statid}) => statid === filtr1 || statid === filtr2 || statid === filtr3 || statid === filtr4 )}, () => { this.brakdanych() });
  this.setState({ dataf : data1 }, () => { this.brakdanych() });
  }

  brakdanych() { 
    let {dataf} = this.state;
    if(dataf.length > 0){
    this.setState({ isVisible: true, isVisible3: false, isLoadingdane: true, brak: false });
    } else {
    this.setState({ isVisible: false, isVisible3: false, isLoadingdane: false, brak: true });
    }
  }

  sortowanieCyfry = (id) => {
    const { dataf, posortowane } = this.state;
    if (posortowane === 'tak'){
    dataf.sort((a, b) => a[id] - b[id]).reverse()
    this.setState({ dataf, posortowane: '' })
    }
    else {
    dataf.sort((a, b) => a[id] - b[id])    
    this.setState({ dataf, posortowane: 'tak' })
    }
  }

  sortowanieNazwy = (id) => {
    const { dataf, posortowane } = this.state;
    if (posortowane === 'tak'){
    dataf.sort((a, b) => a[id].localeCompare(b[id], 'pl', { sensitivity: 'base' } )).reverse();
    this.setState({ dataf, posortowane: '' })
    }
    else {
    dataf.sort((a, b) => a[id].localeCompare(b[id], 'pl', { sensitivity: 'base' } )); 
    this.setState({ dataf, posortowane: 'tak' })
    }  
  }

  dalej = (statId) => { 
    ReactDOM.render(<App token = {this.state.token} username = {this.state.username} nazwauchwaly = {this.state.nazwauchwaly}  kodoper={this.state.kodoper} nazwastrony={this.state.nazwastrony} id = {this.state.id} sorta={this.state.sorta} rok={this.state.rok} wersjaTabeli={this.wersjaTabeli(statId)} />, document.getElementById("root"));
  }


  getParsedDate(strDate){
    var strSplitDate = String(strDate).split(' ');
    var date = new Date(strSplitDate[0]);
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    
    var yyyy = date.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }
    date =  dd + "-" + mm + "-" + yyyy;
    return date.toString();
    }


  wersjaTabeli = (statId) => {
    if(Number(statId) === 0 || Number(statId) == 1 ||  Number(statId) == 2 || Number(statId) == 3 || Number(statId) === 10 || Number(statId) == 11 ||  Number(statId) == 12 || Number(statId) == 13) { return false }
    else { return true }
  }


  przejdzZadania = (dataRow) => { 
    const wersja = this.wersjaTabeli(dataRow.statid);
    const konfig =  JSON.parse(sessionStorage.getItem("konfig")) ? JSON.parse(sessionStorage.getItem("konfig")) : [];


    ReactDOM.render(<BudzetZadaniowy 
      token={this.state.token} 
      rok={this.state.rok}
      dataRow={dataRow}
      wersjaTabeli={wersja}
      konfig={konfig}
    />, document.getElementById("root"));
  }


  render() {
  const { dataf } = this.state;
  const konfig =  JSON.parse(sessionStorage.getItem("konfig")) ? JSON.parse(sessionStorage.getItem("konfig")) : [];


  return (
  <React.Fragment>
  <div class="container-fluid">
    <h1>Lista dokumentów</h1>
    <hr />

    <div class="table-responsive-xl card">
      <table  class="table table-hover table-sm">   
        { this.state.isVisible ? (
        <thead>
          <tr >
            <th  class="text-center point" onClick={() => this.sortowanieCyfry('lp')}><b>Lp</b></th>
            <th  class="text-center point" onClick={() => this.sortowanieNazwy('nazwa')}><b>Nazwa</b></th>
            <th  class="text-center point" onClick={() => this.sortowanieNazwy('status')}><b>Status</b></th>
            <th  class="text-center point" onClick={() => this.sortowanieNazwy('dataotw')}><b>Data otwarcia</b></th>
            <th  class="text-center point" onClick={() => this.sortowanieNazwy('dataprzyj')}><b>Data przyjęcia </b></th>
            <th  class="text-center"><b></b></th>
          </tr>
        </thead>
        ) : null }
        <tbody>
          {this.state.loading ? (<center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>) : null}
          { this.state.isLoadingdane ? (
            dataf
            .map(user => {
            const { id, lp, nazwa, status, dataotw, dataprzyj } = user;
            const dataf1 = this.getParsedDate(dataotw);
            const dataf2 = this.getParsedDate(dataprzyj);
            return (
                <tr key={lp}>
                  <td><p>{lp}</p></td>
                  <td><p>{nazwa}</p></td>
                  <td><p>{status}</p></td>
                  <td><p>{dataf1}</p></td>
                  <td><p>{dataprzyj === "null" ? null : (<p>{dataf2}</p>) }</p></td>
                  <td>
                  {konfig.budzetKlas && <button  onClick={() => this.zmiana(user)} type="button" name="id" class="btn btn-sm btn-light m-1">Wybierz</button>}
                  {konfig.budzetZad && <button  onClick={() => this.przejdzZadania(user)} type="button" class="btn btn-sm btn-light m-1">Zadania</button>}
                  {/* <button type="button"  class="btn btn-sm btn-light m-1"  onClick={() => ReactDOM.render(<ZadaniaLiniowo token = {this.state.token} rok={this.state.rok} idUchwaly={id}/>, document.getElementById("root"))} >Edycja liniowa</button> */}
                  <button type="button"  class="btn btn-sm btn-light m-1"  onClick={() => ReactDOM.render(<Export_bestia token = {this.state.token} rok={this.state.rok} idUchwaly={id}/>, document.getElementById("root"))} >Export</button>
                  </td>
                </tr>
                );
              })
              ) : null}
          { this.state.isVisible3 ? ( <tr ><td colSpan="13"><center><p>Wybierz wartości</p></center></td></tr> ) : null }
          { this.state.brak ? ( <tr ><td colSpan="13"><center><p>Brak danych</p></center></td></tr> ) : null }
        </tbody>
      </table>
    </div>
  </div>

  </React.Fragment>
      );
    }
  }

